import { render, staticRenderFns } from "./LTconfigurator.vue?vue&type=template&id=496a2e74&"
import script from "./LTconfigurator.vue?vue&type=script&lang=js&"
export * from "./LTconfigurator.vue?vue&type=script&lang=js&"
import style0 from "./LTconfigurator.vue?vue&type=style&index=0&id=496a2e74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports